import { render } from "./TrendCard.vue?vue&type=template&id=02cccafb&scoped=true"
import script from "./TrendCard.vue?vue&type=script&lang=js"
export * from "./TrendCard.vue?vue&type=script&lang=js"

import "./TrendCard.vue?vue&type=style&index=0&id=02cccafb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cccafb"]])

export default __exports__